import { createContext, useContext } from "react";

/** Explicit read scope for embedded company tools. It never changes authentication or the current user. */
export const CompanyReadScope = createContext<string | undefined>(undefined);
export const useCompanyReadScope = () => useContext(CompanyReadScope);
